import { render, staticRenderFns } from "./back-button.vue?vue&type=template&id=69d40dbc&scoped=true&lang=pug&"
import script from "./back-button.ts?vue&type=script&lang=ts&"
export * from "./back-button.ts?vue&type=script&lang=ts&"
import style0 from "./back-button.vue?vue&type=style&index=0&id=69d40dbc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d40dbc",
  null
  
)

export default component.exports